module.exports = __webpack_public_path__ + "static/media/popular-music.aee6b8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/popular-music.png
// module id = 479
// module chunks = 0